<template >
  <div v-if="!isMobile" class="card-boder-bg">
    <div class="balance_basket" v-if="balanceBlu">
      <div class="wrapper_balance" style="border-radius: 0">
        <div class="balance_title" style="border-radius: 0">
          <h1>{{ $t("msg.my_balance") }}</h1>
          <img
            v-if="showBalance"
            src="../../../assets/images/eye-show.svg"
            alt="eye-show"
            @click="showBalance = false"
          />

          <img
            v-else
            src="../../../assets/images/eye-hidden.svg"
            alt="eye-hidden"
            @click="showBalance = true"
          />
        </div>

        <div>
          <div class="balance_value" v-if="showBalance">
            <div class="my_balance_content">
              <img src="../../../assets/images/blue_icon.svg" alt="" />
              <span>{{ balanceBlu.balance | decimalsCrypto(6) }} BLUE</span>
            </div>
          </div>

          <div
            class="balance_value"
            v-if="showBalance && usdtAccount"
            style="margin-top: 10px"
          >
            <div class="my_balance_content">
              <img src="../../../assets/images/coins/coin_USDT.png" alt="" />
              <span>{{ usdtAccount.balance | decimalsCrypto(2) }} USDT</span>
            </div>
          </div>
        </div>


        
      </div>
      <hr />
      <div class="wrapper_balance">
        <h1>{{ $t("msg.my_total_value") }}</h1>
        <div
          class="my_balance_content"
          style="justify-content: end; width: auto"
        >
          <div class="balance_value" v-if="showBalance">
            <div class="my_balance_content">
              <img src="../../../assets/images/coins/coin_USDT.png" alt="" />
              <span v-if="usdtAccount"
                >{{
                  currencyFormat(
                    bluAccount.balance * bluValue[0].value +
                      usdtAccount.balance,
                    "USDT"
                  )
                }}
                USDT</span
              >
              <span v-else
                >{{
                  currencyFormat(bluAccount.balance * bluValue[0].value, "USDT")
                }}
                USDT</span
              >
            </div>
            <p class="other_currencies" @click="toggleModalCurrencies()">
              {{ $t("msg.view_other_currencies") }}
            </p>
          </div>
        </div>
      </div>

      <!-- <hr /> -->
      <!-- <div class="wrapper_balance">
        <h1>{{ $t("msg.blue_club_status")}}</h1>

        <div style="width: 70%; display: flex; justify-content: flex-end">
          <div
            class="column qualification_status"
            v-if="!(blueClubInfo.amount >= 20) && !blueClubInfo.asGift"
          >
            <div class="wrapper_bar">
              <div class="bar">
                <div class="coin_bar m13_t">
                  <span
                    class="coin_bar_filled"
                    :style="{
                      width: [
                        ((blueClubInfo.amount / 20) * 100).toFixed(2) + '%',
                      ],
                    }"
                  ></span>
                </div>
              </div>
            </div>

            <div style="display: flex; justify-content: space-between">
              <div class="blue_image">
                <p>{{ (blueClubInfo.amount).toFixed(2) }} BLUE</p>
              </div>

              <div>
                <span class="left_to_qualification">
                  {{ $tc("msg.need_to_qualify", 1) }}
                  {{ (20 - blueClubInfo.amount).toFixed(2) }} BLUE
                  {{ $tc("msg.to_qualify", 1) }}
                </span>
                <p
                  class="other_currencies"
                  @click="toggleModalBlueClub()"
                  style="text-align: right"
                >
                  {{ $t("msg.member_benefits") }}
                </p>
              </div>
            </div>
          </div>

          <div v-if="blueClubInfo.amount >= 20 && blueClubInfo.staus == 'new'">
            <div class="btn-clain" @click="toggleModalClainBlueClub()">
              {{$t('msg.clain_your_nft')}}
            </div>
            <p
              class="other_currencies"
              @click="toggleModalBlueClub()"
              style="text-align: right; margin-top: 10px"
            >
              {{ $t("msg.member_benefits") }} 
            </p>
          </div>

          <div
            v-if="blueClubInfo.amount >= 20 && blueClubInfo.staus == 'waiting'"
          >
            <div style="display: flex">
              <div style="color: #cb36ee; font-weight: 600;">{{ $t("msg.minting") }} NFT</div>
              <img
                src="../../../assets/images/clock.svg"
                alt="clock"
                style="width: 20px; margin-left: 10px"
              />
            </div>
            <p
              class="other_currencies"
              @click="toggleModalBlueClub()"
              style="text-align: right; margin-top: 10px"
            >
              {{ $t("msg.member_benefits") }} 
            </p>
          </div>

          <div v-if="(blueClubInfo.amount >= 20 && blueClubInfo.staus == 'done') || (blueClubInfo.asGift)">
            <div class="btn-clain" @click="openSolonaNFT()">
              {{ $t("msg.my") }} NFT
            </div>
            <p
              class="other_currencies"
              @click="toggleModalBlueClub()"
              style="text-align: right; margin-top: 10px"
            >
              {{ $t("msg.member_benefits") }} 
            </p>
          </div>
        </div>
      </div> -->
    </div>

    <div v-else class="component_card combo_1 balance_basket">
      <loading></loading>
    </div>
  </div>

  <div class="tabs_mobile" v-else>
    <div class="tab">
      <input class="tab_input" type="checkbox" id="balance" />
      <label class="tab-label">
        <div style="display: flex">
          {{ $t("msg.my_balance") }}
          <img
            class="eye_balance"
            v-if="showBalance"
            src="../../../assets/images/eye-show.svg"
            alt="eye-show"
            @click="showBalance = false"
          />

          <img
            class="eye_balance"
            v-else
            src="../../../assets/images/eye-hidden.svg"
            alt="eye-hidden"
            @click="showBalance = true"
          />
        </div>

        <div class="tab_balance" v-if="showBalance">
          <img src="../../../assets/images/blue_icon.svg" alt="" />
          <span>{{ balanceBlu.balance | decimalsCrypto(6) }} BLUE</span>
        </div>
      </label>

      <div class="tab-content">
        <div class="balance_basket" v-if="usdtValue[0]">
          <div class="wrapper_balance">
            <h1>{{ $t("msg.my_total_value") }}</h1>
            <div
              class="my_balance_content"
              style="justify-content: end; width: auto"
            >
              <div class="balance_value" v-if="showBalance">
                <div class="my_balance_content">
                  <img
                    src="../../../assets/images/coins/coin_USDT.png"
                    alt=""
                  />
                  <span
                    >{{
                      currencyFormat(
                        bluAccount.balance * bluValue[0].value,
                        "USDT"
                      )
                    }}
                    USDT</span
                  >
                </div>
                <p class="other_currencies" @click="toggleModalCurrencies()">
                  {{ $t("msg.view_other_currencies") }}
                </p>
              </div>
            </div>
            <span></span>
          </div>

          <div class="wrapper_balance" style="margin-top: 15px;">
            <h1>{{ $t("msg.blue_club_status")}}</h1>
            <div style="display: flex; justify-content: flex-end">
          <div
            class="column qualification_status"
            v-if="!(blueClubInfo.amount >= 20) && !blueClubInfo.asGift"
          >
            <div class="wrapper_bar">
              <div class="bar">
                <div class="coin_bar m13_t">
                  <span
                    class="coin_bar_filled"
                    :style="{
                      width: [
                        ((blueClubInfo.amount / 20) * 100).toFixed(2) + '%',
                      ],
                    }"
                  ></span>
                </div>
              </div>
            </div>

            <div style="display: flex; justify-content: space-between; font-size: 0.7rem;">
              <div class="blue_image">
                <p>{{ (blueClubInfo.amount).toFixed(2) }} BLUE</p>
              </div>

              <div>
                <span class="left_to_qualification">
                  {{ $tc("msg.need_to_qualify", 1) }}
                  {{ (20 - blueClubInfo.amount).toFixed(2) }} BLUE
                  {{ $tc("msg.to_qualify", 1) }}
                </span>
                <p
                  class="other_currencies"
                  @click="toggleModalBlueClub()"
                  style="text-align: right"
                >
                  {{ $t("msg.member_benefits") }}
                </p>
              </div>
            </div>
          </div>

          <div v-if="blueClubInfo.amount >= 20 && blueClubInfo.staus == 'new'">
            <div class="btn-clain" @click="toggleModalClainBlueClub()">
              {{$t('msg.clain_your_nft')}}
            </div>
            <p
              class="other_currencies"
              @click="toggleModalBlueClub()"
              style="text-align: right; margin-top: 10px"
            >
              {{ $t("msg.member_benefits") }}
            </p>
          </div>

          <div
            v-if="blueClubInfo.amount >= 20 && blueClubInfo.staus == 'waiting'"
          >
            <div style="display: flex">
              <div style="color: #cb36ee">{{ $t("msg.minting") }} NFT</div>
              <img
                src="../../../assets/images/clock.svg"
                alt="clock"
                style="width: 20px; margin-left: 10px"
              />
            </div>
            <p
              class="other_currencies"
              @click="toggleModalBlueClub()"
              style="text-align: right; margin-top: 10px"
            >
              {{ $t("msg.member_benefits") }}
            </p>
          </div>

          <div v-if="(blueClubInfo.amount >= 20 && blueClubInfo.staus == 'done') || blueClubInfo.asGift">
            <div class="btn-clain" @click="openSolonaNFT()">
              {{ $t("msg.my") }} NFT
            </div>
            <p
              class="other_currencies"
              @click="toggleModalBlueClub()"
              style="text-align: right; margin-top: 10px"
            >
              {{ $t("msg.member_benefits") }}
            </p>
          </div>
        </div>
        <div></div>
          </div>
        </div>
        <div v-else class="component_card combo_1 balance_basket">
          <loading></loading>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import loading from "../../public/LoadingCoinsSlider.vue";
import { mapGetters } from "vuex";

export default {
  created() {
    this.getRewardCheck();

    this.getAccounts();
    this.checkIfMobile();
    this.getFundTails();
  },
  mounted() {
    window.addEventListener("resize", this.checkIfMobile);
  },
  data: () => ({
    cryptoEquivalence: ["BTC", "ETH", "RAS", "USDT"], //remove
    BTC: "", //remove
    ETH: "", //remove
    RAS: "", //remove
    USDT: "",
    balanceBlu: "",
    fundTails: "",
    modalCurrencies: false,
    showBalance: true,
    isMobile: false,
    myBalanceExpand: false,
    blueClubInfo: {
      amount: 0,
      received: false,
      staus: "new",
      nftAddress: "",
      asGift: false,
    },
  }),
  components: {
    loading,
  },
  methods: {
    currencyFormat(num, symb) {
      if (symb == "RAS" || symb == "USDT") {
        return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      } else {
        return num.toFixed(8);
      }
    },

    toggleModalCurrencies() {
      this.$emit("toggleModalCurrencies");
    },

    toggleModalBlueClub() {
      this.$emit("toggleModalBlueClub");
    },

    toggleModalClainBlueClub() {
      this.$emit("toggleModalClainBlueClub");
    },

    openSolonaNFT() {


      console.log(this.blueClubInfo, 'aquiii')
      window.open(`https://solscan.io/token/${this.blueClubInfo.nftAddress}`, "_blank");
    },

    toggleMenu() {
      this.myBalanceExpand = !this.myBalanceExpand;
    },

    async getAccounts() {
      let response = await this.$store.dispatch("getAccounts");
      if (response.status == 200) {
        let accouns = response.data;
        this.filterBlueAccounst(accouns);
      } else {
        alert("error to get balances");
      }
    },

    async getRewardCheck() {
      let response = await this.$store.dispatch("getRewardCheck");

      console.log(response)
      
      if (response.status == 200) {
        if (response.data.amount > 0) {
          this.blueClubInfo.amount = response.data.amount;
          
        }
        if(response.data.received){
          this.blueClubInfo.received = response.data.received;
        }

        if (response.data.status) {
          this.blueClubInfo.staus = response.data.status;
        }

        if (response.data.nftAddress) {
          this.blueClubInfo.nftAddress = response.data.nftAddress;
        }

        if (response.data.received) {
          this.blueClubInfo.asGift = response.data.received;
        }
      } else {
        alert("error to get balances");
      }
    },

    filterBlueAccounst(el) {
      for (let i in el) {
        if (el[i].currency.symbol == "BLU") {
          this.balanceBlu = el[i];
          console.log(this.balanceBlu);
        }
      }
    },

    returnBySymbol(symbol) {
      if (symbol == "USDT" || symbol == "RAS") {
        if (this[symbol].value) {
          return this[symbol].value.toFixed(2);
        }
      } else {
        if (this[symbol].value) {
          return this[symbol].value.toFixed(8);
        }
      }
    },

    currencyFormat(num, symb) {
      if (symb == "RAS" || symb == "USDT") {
        return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      } else {
        return num.toFixed(8);
      }
    },

    async getFundTails() {
      let params = {
        offset: 0,
        limit: 50,
        entryType: "live",
      };
      try {
        let resp = await this.$store.dispatch("getFundTails", params);
        this.fundTails = resp.data;
      } catch (e) {
        console.log("error ", e);
      }
    },

    checkIfMobile() {
      let w = window,
        x = w.innerWidth;

      if (x > 900) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    },
  },
  computed: {
    ...mapGetters(["bluAccount", "usdtValue", "bluValue", "usdtAccount"]),
  },
  watch: {},
};
</script>


<style lang="scss" scope>
.btn-clain {
  background: #cb36ee;
  padding: 10px;
  color: white;
  border-radius: 10px;
  text-align: center;
  cursor: pointer;
  &:active {
    opacity: 0.5;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/private/landing/LandingBalance2.vue